module.exports = __webpack_public_path__ + "media/honey-icons/icon-signal-booster-uk-9972c4b4.svg";